import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTable } from 'react-table';
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingAnimation from '../loading-animation';
import './data-grid.scss';

export const DataGrid = ({data, columnData, hasMore, hiddenColumns, isLoading, length, onNext, onRowClick}) => {
	const columns = useMemo(() => columnData,[columnData]);
	const {
	  getTableProps,
	  getTableBodyProps,
	  headerGroups,
	  rows,
	  prepareRow,
	} = useTable({ columns, data, initialState: {hiddenColumns} });

	const renderCell = cell => {
		return <td {...cell.getCellProps()} className={`grid-td-${cell.column.id}`}>{cell.render('Cell')}</td>
	};

	return (
		<div className="data-grid">
			<div className="data-grid-header">
				<table {...getTableProps()} className="data-grid-table" cellPadding="0" cellSpacing="0">
					<thead>
						{headerGroups.map(headerGroup => (
							<tr {...headerGroup.getHeaderGroupProps()}>
								{headerGroup.headers.map(column => (
									<th {...column.getHeaderProps()} className={`grid-th-${column.id}`}>{column.render('Header')}</th>
								))}
							</tr>
						))}
					</thead>
				</table>
			</div>
			<div className="data-grid-body" id="dataGrid">
				<InfiniteScroll
					dataLength={length}
					next={onNext}
					hasMore={hasMore}
					loader={<div className="data-grid-scroll-loading"><LoadingAnimation text="Loading..." inline /></div>}
					scrollableTarget="dataGrid"
					scrollThreshold={.5}
				>
					<table {...getTableProps()} className="data-grid-table" cellPadding="0" cellSpacing="0">

						<tbody {...getTableBodyProps()}>
						{isLoading ?
							<tr>
								<td colSpan={headerGroups[0].headers.length} className="grid-loading-cell">
									<div><LoadingAnimation text="Loading..."/></div>
								</td>
							</tr> :
							rows.map(row => {
								prepareRow(row);
								return (
									<tr {...row.getRowProps()} key={row.original.id} onClick={() => {onRowClick && onRowClick(row)}}>
										{row.cells.map(renderCell)}
									</tr>
								)
							})
						}
						</tbody>
					</table>
				</InfiniteScroll>
			</div>
		</div>
	);
}

DataGrid.propTypes = {
	data: PropTypes.array,
	columnData: PropTypes.array,
	hiddenColumns: PropTypes.array,
	isLoading: PropTypes.bool
};

export default DataGrid;
